import httpClient from "./httpClient";

const candidatureService = {
  
  checkCandidatureInfo(id,interested){
    return httpClient.post(`/api/candidature/interest?guid=${id}&&interested=${interested}`);
  },

  checkRelanceCandidatureInfo(id,interested){
    return httpClient.post(`/api/candidature/relance-interest?guid=${id}&interested=${interested}`);
  }
  



};

export default candidatureService;
